import { Grid, Paper } from '@mui/material';
import moment from 'moment';
import { useSnackbar } from 'notistack';
import { SubmitHandler } from 'react-hook-form';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router';
import * as api from '../../api/app/shiftsApi';
import { PageContent } from '../../components/core/PageContent/PageContent';
import { PageHeader } from '../../components/core/PageHeader/PageHeader';
import { useTranslation } from '../../contexts/translation';
import { ShiftInputs } from '../../types/app/shifts.types';
import { convertDataFromInputToCreateRequest } from '../../utils/core/functions/shift.functions';
import { TimeFormatTypes } from '../../utils/core/functions/timeFormat.functions';
import { paths } from '../../utils/core/routes';
import { ShiftForm } from './ShiftForm';
import { useStyles } from './ShiftForm.styles';

export function ShiftCreate() {
  const { t } = useTranslation();

  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const { mutate: mutateCreateShift } = useMutation(api.createShift);

  const handleOnSubmit: SubmitHandler<ShiftInputs> = (data: ShiftInputs) => {
    const requestData = convertDataFromInputToCreateRequest({
      ...data,
      start: moment(data.start).format(TimeFormatTypes.HH_mm + ':00'),
      end: moment(data.end).format(TimeFormatTypes.HH_mm + ':00'),
    });

    mutateCreateShift(
      { ...requestData },
      {
        onSuccess: () => {
          enqueueSnackbar(t('page.shift.item-created'), { variant: 'success' });
          navigate(paths.SHIFTS_LIST);
        },
        onError: (result: any) => {
          enqueueSnackbar(`${result}`, { variant: 'error' });
        },
      },
    );
  };

  return (
    <>
      <PageHeader title={t('page.shift.headline-create')} />
      <PageContent>
        <Grid container spacing={1}>
          <Grid item xs={12} md={8} lg={4}>
            <Paper className={classes.paper}>
              <ShiftForm onSubmit={handleOnSubmit} onBack={() => navigate(paths.SHIFTS_LIST)} />
            </Paper>
          </Grid>
        </Grid>
      </PageContent>
    </>
  );
}
